// create a react component that will be used to display the data

import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../contexts/auth';
import { assignConsulente, deleteConsulente, fetchConsulenti, getConsulenti } from '../services/api';
import Swal from 'sweetalert2';
import { estraiMessaggiErrore } from '../services/utils';


export default function ChooseConsulente() {
  const { profile, token, setProfile } = useContext(AuthContext)
  // State to hold the input value
  const [inputValue, setInputValue] = useState('');
  // State to hold the search results
  const [searchResults, setSearchResults] = useState([]);
  const [consulenti, setConsulenti] = useState([])

  const [searchError, setSearchError] = useState(null)

  // State to hold the current Axios source, used to cancel the request if needed
  const [source, setSource] = useState(axios.CancelToken.source());

  const [loading, setLoading] = useState(false)

  const assignConsultant = async (consultant) => {


    Swal.fire({
      title: `Vuoi assegnare ${consultant.visible_name} come consulente?`,
      showDenyButton: true,
      confirmButtonText: 'Conferma',
      denyButtonText: `Annulla`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setSearchResults([]);
          const res = await assignConsulente(token, consultant.id);
          setConsulenti([...consulenti, consultant]);
          Swal.fire('Il consulente ti è stato correttamente assegnato', '', 'success');
        } catch (error) {
          const errorMessage = estraiMessaggiErrore(error);
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: errorMessage,
          });
        } finally {
          setLoading(false);
        }
      } else if (result.isDenied) {
        Swal.fire('Operazione annullata', '', 'info');
      }
    });
  };


  const cancelConsultant = async (consultant) => {
    Swal.fire({
      title: `Sei sicuro di voler cancellare ${consultant.visible_name} come consulente?`,
      showDenyButton: true,
      confirmButtonText: 'Conferma',
      denyButtonText: `Annulla`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setSearchResults([]);
          const res = await deleteConsulente(token, consultant.id);
          setConsulenti([]);
          Swal.fire('Il consulente è stato correttamente rimosso dal tuo account', '', 'success');
          console.log(res);
        } catch (error) {
          const errorMessage = estraiMessaggiErrore(error);
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: errorMessage,
          });
        } finally {
          setLoading(false);
        }
      } else if (result.isDenied) {
        Swal.fire('Operazione annullata', '', 'info');
      }
    });
  };


  useEffect(() => {
    getConsulenti(token).then(data => {
      setConsulenti(data)
    }).catch(err => {
      console.log(err)
    })
  }, [])

  useEffect(() => {
    // Check for inputValue and fetch the data
    if (inputValue.length > 4) {
      setLoading(true)
      fetchConsulenti(token, inputValue).then(data => {
        // Update the search results if data is fetched successfully
        if (data) {
          setLoading(false)
          setSearchResults(data);
          console.log(data)
          setSearchError(null)
        }
      }).catch(err => {
        // Update the search results if there is an error
        setLoading(false)
        console.log(err.response)
        setSearchError(`${err.response.data.detail} - Verifica di avere inserito l'email o il codice fiscale corretto`)
        setSearchResults([]);
      })
    }

    // Cleanup function
    return () => {
      source.cancel('Component unmounted');
    };
  }, [inputValue]);

  if (consulenti.length === 0) {
    return (
      <div>
        {/* Input element to take user input */}
        <input
          type="text"
          className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Cerca..."
        />
        {loading && <p>Loading...</p>}
        {/* Display search results in a list */}
        <ul role="list" className="divide-y divide-gray-100">
          {
            searchError && <li className="px-4 py-4 sm:px-6">
              <div className="flex items-center justify-between flex-wrap gap-x-4">
                <div className="flex-1 flex items-center gap-x-4 min-w-0">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" clipRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 7a1 1 0 112 0v4a1 1 0 11-2 0V7zm1 11a1 1 0 100-2 1 1 0 000 2z" />
                    </svg>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm leading-5 font-medium text-red-600">
                      {searchError}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          }
          {searchResults.map((person, index) => (
            <li key={index} className="flex justify-between gap-x-6 py-5">
              <div className="flex min-w-0 gap-x-4">
                <div className="min-w-0 flex-auto">
                  <p className="text-sm font-semibold leading-6 text-gray-900">{person.visible_name}</p>
                  <p className="mt-1 truncate text-xs leading-5 text-gray-500">{person.email}</p>
                </div>
              </div>
              <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                <p className="text-sm leading-6 text-gray-900">{person.cf}</p>
                <p className="mt-1 text-xs leading-5 text-gray-500">
                  <button className="text-purple-600 hover:text-purple-900"
                    onClick={() => { assignConsultant(person) }}
                  >Assegna</button>
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  } else {
    return <div>
      <p>Consulente assegnato: {consulenti[0]?.visible_name}</p>
      <button className="text-purple-600 hover:text-purple-900"
        onClick={() => { cancelConsultant(consulenti[0]) }}
      >Elimina</button>
    </div>
  }
}
